module.exports = __webpack_public_path__ + "img/-LV19sucxUWS6m3Sooau.5954402f.jpg";